// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/styles/History.css - UPDATED WITH LIGHT THEME */

.history-page .page-container {
  /* Use the main content background */
  background: var(--gradient-hero);
  padding-top: var(--navbar-height); /* Ensure spacing below navbar */
  min-height: calc(100vh - var(--navbar-height));
  padding-bottom: 4rem; /* Add some bottom padding */
}

.history-page .container {
  max-width: 900px;
}

.history-page-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.history-page-header h1 {
  font-size: clamp(2rem, 5vw, 2.8rem);
  color: var(--text-primary); /* Dark text */
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.history-page-header p {
  font-size: clamp(1rem, 2vw, 1.1rem);
  color: var(--text-secondary); /* Medium gray text */
}

.history-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.history-item {
  display: flex;
  align-items: center;
  background: var(--bg-primary); /* White background */
  padding: 1.25rem 1.5rem;
  border-radius: var(--border-radius-xl); /* Consistent radius */
  border: 1px solid var(--border-primary); /* Light gray border */
  transition: all 0.3s ease;
  box-shadow: var(--shadow-lg); /* Add subtle shadow */
}

.history-item:hover {
  transform: translateY(-3px);
  border-color: var(--text-accent); /* Red border on hover */
  box-shadow: var(--shadow-xl); /* Slightly larger shadow on hover */
}

.history-item-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  background: var(--bg-accent-light); /* Light red tint background */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1.5rem;
}

.history-item-icon svg {
  width: 20px;
  height: 20px;
  color: var(--text-accent); /* Red icon color */
}

.history-item-details {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 0.25rem;
}

.history-filename {
  font-weight: 600; /* Bolder filename */
  color: var(--text-primary); /* Dark text */
  font-size: 1rem;
}

.history-jd-snippet {
  font-size: 0.9rem;
  color: var(--text-secondary); /* Medium gray text */
  margin: 0.25rem 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 500px; /* Adjust as needed */
}

.history-jd-snippet strong {
  color: var(--text-primary); /* Darker text for "For:" */
  font-weight: 500;
}

.history-date {
  font-size: 0.85rem;
  color: var(--text-secondary); /* Medium gray text */
}

.history-status {
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.3rem 0.8rem;
  border-radius: var(--border-radius-full); /* Pill shape */
  text-transform: uppercase;
  margin-left: auto; /* Push status to the right */
  flex-shrink: 0; /* Prevent shrinking */
}

.history-status.status-completed {
  background-color: var(--success-bg-light); /* Light green background */
  color: var(--success-color); /* Green text */
}

.history-status.status-failed {
  background-color: var(--error-bg-light); /* Light red background */
  color: var(--error-color); /* Red text */
}
.history-status.status-pending { /* Added style for pending */
    background-color: var(--warning-bg-light); /* Light yellow/amber */
    color: var(--warning-color); /* Amber text */
}

.no-history {
  text-align: center;
  padding: 3rem;
  background: var(--bg-secondary); /* Very light gray */
  border-radius: var(--border-radius-xl);
  border: 1px dashed var(--border-primary); /* Light dashed border */
}

.no-history p {
  color: var(--text-secondary); /* Medium gray text */
}`, "",{"version":3,"sources":["webpack://./src/styles/History.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,oCAAoC;EACpC,gCAAgC;EAChC,iCAAiC,EAAE,gCAAgC;EACnE,8CAA8C;EAC9C,oBAAoB,EAAE,4BAA4B;AACpD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B,EAAE,cAAc;EAC1C,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B,EAAE,qBAAqB;AACrD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B,EAAE,qBAAqB;EACpD,uBAAuB;EACvB,sCAAsC,EAAE,sBAAsB;EAC9D,uCAAuC,EAAE,sBAAsB;EAC/D,yBAAyB;EACzB,4BAA4B,EAAE,sBAAsB;AACtD;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC,EAAE,wBAAwB;EAC1D,4BAA4B,EAAE,oCAAoC;AACpE;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kCAAkC,EAAE,8BAA8B;EAClE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB,EAAE,mBAAmB;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB,EAAE,oBAAoB;EACtC,0BAA0B,EAAE,cAAc;EAC1C,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B,EAAE,qBAAqB;EACnD,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB,EAAE,qBAAqB;AACzC;;AAEA;EACE,0BAA0B,EAAE,2BAA2B;EACvD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B,EAAE,qBAAqB;AACrD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC,EAAE,eAAe;EACzD,yBAAyB;EACzB,iBAAiB,EAAE,6BAA6B;EAChD,cAAc,EAAE,sBAAsB;AACxC;;AAEA;EACE,yCAAyC,EAAE,2BAA2B;EACtE,2BAA2B,EAAE,eAAe;AAC9C;;AAEA;EACE,uCAAuC,EAAE,yBAAyB;EAClE,yBAAyB,EAAE,aAAa;AAC1C;AACA,iCAAiC,4BAA4B;IACzD,yCAAyC,EAAE,uBAAuB;IAClE,2BAA2B,EAAE,eAAe;AAChD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B,EAAE,oBAAoB;EACrD,sCAAsC;EACtC,wCAAwC,EAAE,wBAAwB;AACpE;;AAEA;EACE,4BAA4B,EAAE,qBAAqB;AACrD","sourcesContent":["/* frontend/src/styles/History.css - UPDATED WITH LIGHT THEME */\n\n.history-page .page-container {\n  /* Use the main content background */\n  background: var(--gradient-hero);\n  padding-top: var(--navbar-height); /* Ensure spacing below navbar */\n  min-height: calc(100vh - var(--navbar-height));\n  padding-bottom: 4rem; /* Add some bottom padding */\n}\n\n.history-page .container {\n  max-width: 900px;\n}\n\n.history-page-header {\n  text-align: center;\n  margin-bottom: 2.5rem;\n}\n\n.history-page-header h1 {\n  font-size: clamp(2rem, 5vw, 2.8rem);\n  color: var(--text-primary); /* Dark text */\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.history-page-header p {\n  font-size: clamp(1rem, 2vw, 1.1rem);\n  color: var(--text-secondary); /* Medium gray text */\n}\n\n.history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.history-item {\n  display: flex;\n  align-items: center;\n  background: var(--bg-primary); /* White background */\n  padding: 1.25rem 1.5rem;\n  border-radius: var(--border-radius-xl); /* Consistent radius */\n  border: 1px solid var(--border-primary); /* Light gray border */\n  transition: all 0.3s ease;\n  box-shadow: var(--shadow-lg); /* Add subtle shadow */\n}\n\n.history-item:hover {\n  transform: translateY(-3px);\n  border-color: var(--text-accent); /* Red border on hover */\n  box-shadow: var(--shadow-xl); /* Slightly larger shadow on hover */\n}\n\n.history-item-icon {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  background: var(--bg-accent-light); /* Light red tint background */\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 1.5rem;\n}\n\n.history-item-icon svg {\n  width: 20px;\n  height: 20px;\n  color: var(--text-accent); /* Red icon color */\n}\n\n.history-item-details {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  gap: 0.25rem;\n}\n\n.history-filename {\n  font-weight: 600; /* Bolder filename */\n  color: var(--text-primary); /* Dark text */\n  font-size: 1rem;\n}\n\n.history-jd-snippet {\n  font-size: 0.9rem;\n  color: var(--text-secondary); /* Medium gray text */\n  margin: 0.25rem 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 500px; /* Adjust as needed */\n}\n\n.history-jd-snippet strong {\n  color: var(--text-primary); /* Darker text for \"For:\" */\n  font-weight: 500;\n}\n\n.history-date {\n  font-size: 0.85rem;\n  color: var(--text-secondary); /* Medium gray text */\n}\n\n.history-status {\n  font-size: 0.8rem;\n  font-weight: 600;\n  padding: 0.3rem 0.8rem;\n  border-radius: var(--border-radius-full); /* Pill shape */\n  text-transform: uppercase;\n  margin-left: auto; /* Push status to the right */\n  flex-shrink: 0; /* Prevent shrinking */\n}\n\n.history-status.status-completed {\n  background-color: var(--success-bg-light); /* Light green background */\n  color: var(--success-color); /* Green text */\n}\n\n.history-status.status-failed {\n  background-color: var(--error-bg-light); /* Light red background */\n  color: var(--error-color); /* Red text */\n}\n.history-status.status-pending { /* Added style for pending */\n    background-color: var(--warning-bg-light); /* Light yellow/amber */\n    color: var(--warning-color); /* Amber text */\n}\n\n.no-history {\n  text-align: center;\n  padding: 3rem;\n  background: var(--bg-secondary); /* Very light gray */\n  border-radius: var(--border-radius-xl);\n  border: 1px dashed var(--border-primary); /* Light dashed border */\n}\n\n.no-history p {\n  color: var(--text-secondary); /* Medium gray text */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
